(function ($) {
  $(window).on("load", function () {
    $("#siteLogo, #customer-portal-logo").css("opacity", "1");
  });

  $(document).ready(function () {
    $("[data-aos]").each(function () {
      $(this).addClass("aos-init");
    });

    // Fix SVG logo having no width and height
    let logoHeight = $(".site-menu #siteLogo").attr("height");
    let logoWidth = $(".site-menu #siteLogo").attr("width");
    if (logoHeight) {
      $(".site-menu a.site-logo").css({
        width: logoWidth + "px",
        height: logoHeight + "px",
      });
      $(".site-logo img").css("height", logoHeight + "px");
    } else {
      $(".site-menu a.site-logo").css({ width: "149px", height: "32px" });
      $(".site-logo img").css("height", "32px");
    }

    // Menu animations
    $("#trigger").click(function () {
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $("body").removeClass("disable");
        $("#siteLogo").animate({ top: "-300px" }, 300, function () {
          $(this).animate({ top: "10px" });
          $(this).removeClass("reposition");
          $(this).removeClass("colour-change");
        });
        $("#social").animate({ bottom: "-100px" }, 750, function () {
          $(this).delay(500).animate({ bottom: "0px" });
          $(this).removeClass("reposition");
          $(this).removeClass("colour-change");
        });
        $("#mainMenu a").css("color", "#323E48");
        $("#mainMenu").delay(500).animate({ left: "-100vw" }).fadeOut(1000);
      } else {
        $("body").addClass("disable");
        $(this).addClass("open");
        $("#triggerContainer").css("top", "30px");

        $("#siteLogo").animate({ top: "-300px" }, 750, function () {
          $(this).delay(500).animate({ top: "0px" });
          $("#siteLogo").addClass("colour-change");
        });
        $("#social")
          .addClass("reposition")
          .animate({ bottom: "-100px" }, 750, function () {
            $(this).delay(500).css("z-index", 99).animate({ bottom: "0px" });
          });
        $("#mainMenu a").css("color", "#323E48");
        $("#mainMenu").fadeIn(100).animate({ left: "0" });
      }
    });

    $("#mainMenu a").on("click", function () {
      if ($("#trigger").hasClass("open")) {
        $("#trigger").removeClass("open");
        $("body").removeClass("disable");
        $("#siteLogo").animate({ top: "-300px" }, 1000, function () {
          $(this).delay(500).css("z-index", 1).animate({ top: "10px" });
          $(this).removeClass("reposition");
          $(this).removeClass("colour-change");
        });
        $("#social").animate({ bottom: "-100px" }, 750, function () {
          $(this).delay(500).animate({ bottom: "0px" });
          $(this).removeClass("reposition");
        });
        $("#mainMenu").delay(500).animate({ left: "-100vw" }).fadeOut(1000);
      }
    });

    // Slick Sliders
    if ($(".slider-testimonials").length) {
      $(".slider-testimonials").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }

    if ($(".success-slider").length) {
      $(".success-slider")
        .on("init", function (event, slick) {
          $(".success-slider .d-none").removeClass("d-none");
          $(".success-slider .slick-slide").attr({ "aria-hidden": "true", inert: "", tabindex: "-1" });
          $(".success-slider .slick-current").attr({ "aria-hidden": "false" }).removeAttr("inert tabindex");
        })
        .on("afterChange", function (event, slick, currentSlide) {
          $(".success-slider .slick-slide").attr({ "aria-hidden": "true", inert: "", tabindex: "-1" });
          $(".success-slider .slick-slide[data-slick-index='" + currentSlide + "']")
            .attr({ "aria-hidden": "false" })
            .removeAttr("inert tabindex");
        })
        .slick({
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 700,
          dots: true,
          arrows: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
    }

    if ($(".features-slider").length) {
      $(".features-slider").slick({
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    if ($(".related-products-slider").length) {
      $(".related-products-slider").slick({
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    if ($(".documents-slider").length) {
      $(".documents-slider").slick({
        autoplay: false,
        speed: 700,
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      $(".downloads-listing").each(function () {
        var totalSlides = $(this).find(".slick-slide").length;
        if (totalSlides < 4) {
          $(this).find(".document-slider-nav").hide();
        }
      });

      $(".document-slider-nav .next-slide").click(function () {
        var documentSlider = $(this)
          .closest(".title-wrapper")
          .siblings(".download-category")
          .find(".documents-slider")
          .slick("slickNext");
      });
      $(".document-slider-nav .prev-slide").click(function () {
        var documentSlider = $(this)
          .closest(".title-wrapper")
          .siblings(".download-category")
          .find(".documents-slider")
          .slick("slickPrev");
      });
    }

    if ($(".slideshow_thumbs").length) {
      $(".slideshow_thumbs").slick({
        infinite: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
      });
    }

    if ($(".gallery-slider").length) {
      $(".gallery-slider").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerMode: true,
        centerPadding: "0px",
        asNavFor: ".gallery-slider-details",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerPadding: "40px",
            },
          },
        ],
      });

      $(".gallery-slider-details").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".gallery-slider",
        dots: true,
      });
    }

    // colour swatches
    if ($(".colour-slider").length) {
      var colourSlidesToShow = $("#js-colour-slides-to-show").val();
      var colourSlider = $(".colour-slider").slick({
        infinite: true,
        arrows: false,
        slidesToShow: parseInt(colourSlidesToShow),
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerPadding: "40px",
            },
          },
        ],
      });

      $(".colour-slider-nav .outer-circle").click(function () {
        var slide = $(this).data("slide");

        $(".colour-slider ").slick("slickGoTo", slide - 1);
        $(".colour-slider-nav .slick-active").removeClass("slick-active");
        $(this).addClass("slick-active");
      });

      colourSlider.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          var highlightedNav = currentSlide + 1;
          $(".colour-slider-nav .slick-active").removeClass("slick-active");
          $(
            '.colour-slider-nav .outer-circle[data-slide="' +
              highlightedNav +
              '"]',
          ).addClass("slick-active");
        },
      );
    }

    // glass swatches
    if ($(".glass-slider").length) {
      var glassSlidesToShow = $("#js-glass-slides-to-show").val();
      var glassSlider = $(".glass-slider").slick({
        infinite: true,
        arrows: false,
        slidesToShow: parseInt(glassSlidesToShow),
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerPadding: "40px",
            },
          },
        ],
      });

      $(".glass-slider-nav .outer-circle").click(function () {
        var slide = $(this).data("slide");

        $(".glass-slider ").slick("slickGoTo", slide - 1);
        $(".glass-slider-nav .slick-active").removeClass("slick-active");
        $(this).addClass("slick-active");
      });

      glassSlider.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          var highlightedNav = currentSlide + 1;
          $(".glass-slider-nav .slick-active").removeClass("slick-active");
          $(
            '.glass-slider-nav .outer-circle[data-slide="' +
              highlightedNav +
              '"]',
          ).addClass("slick-active");
        },
      );
    }

    if ($(".slider-nav").length) {
      $(".slider-nav").slick({
        asNavFor: ".slider-for",
        dots: false,
        arrows: false,
        draggable: true,
        swipeToSlide: true,
        centerMode: true,
        centerPadding: "50px",
        slidesToShow: 5,
        slidesToScroll: 5,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              centerMode: true,
              centerPadding: "50px",
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });
    }

    // Lockmaster slider
    if ($(".lockmaster-slider").length) {
      $(".lockmaster-slider").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".lockmaster-slider-details",
        fade: true,
        cssEase: "linear",
        speed: 200,
      });

      $(".lockmaster-slider-details").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".lockmaster-slider",
        dots: true,
      });
    }

    //Stop modal videos on close
    var heroVideo = $("#heroModal iframe").attr("src") + "&autoplay=1";
    $("#heroModal").on("hide.bs.modal", function (e) {
      $("#heroModal iframe").attr("src", "");
    });
    $("#heroModal").on("show.bs.modal", function (e) {
      $("#heroModal iframe").attr("src", heroVideo);
    });

    // Initiate aos animations
    AOS.init({
      once: true,
    });

    // Remove empty paragraphs
    $("p:empty:not([role])").remove();

    // Remove p tags around images when using the WYSIWYG advanced custom field
    $("p > img").unwrap();

    // Hide title attribute from images and vimeo videos
    $(".preview-vimeo, .ssp-image, .news-image, .product-image, .rp-image")
      .data("title", $(this).attr("title"))
      .removeAttr("title");

    if ($(window).width() < 1200) {
      var ico = $('<span class="fa fa-chevron-down"></span>');
      $("#mainMenu li:has(ul)").append(ico);

      $("#mainMenu span.fa-chevron-down").on("click", function () {
        $(this).parent("li").toggleClass("opened");
        $(this).siblings("ul").slideToggle();
      });

      if ($(".fullpage-status").attr("id", "fullpage")) {
        $(".fullpage-status").attr("id", "no-fullpage");
      }

      $("body")[0].classList.add("no-fullpage");
    }

    if ($(window).width() > 1199) {
      var ico = $('<span class="fa fa-chevron-down"></span>');
      $("#mainMenu li:has(ul)").remove(ico);

      $(".product-page-module").removeAttr("id");
    }

    $(window).scroll(function () {
      if ($(document).scrollTop() > 400) {
        $("#no-fullpage .product-section-nav").addClass("show");
        $(".trigger-container").addClass("show");
      } else {
        $("#no-fullpage .product-section-nav").removeClass("show");
        $(".trigger-container").removeClass("show");
      }
    });

    // Activate fullpage.js and add aos fix
    if ($("body").hasClass("has-secondary-nav")) {
      let anchor_names = $("#section-names").data("sections") || "";
      let menu_name = $("#menu-name").data("menu") || false;

      if ($(window).width() < 1200) {
        $("li", menu_name).click(function (e) {
          e.preventDefault();

          let anchor = $(this).data("menuanchor");
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $("section[data-anchor=" + anchor + "]").offset().top,
            },
            {
              duration: 700,
              easing: "linear",
            },
          );
        });
      } else {
        if (document.querySelector("#fullpage")) {
          new fullpage("#fullpage", {
            scrollOverflow: true,
            lockAnchors: false,
            normalScrollElements: "#heroModal",
            css3: false,
            anchors: [anchor_names],
            menu: menu_name,

            afterSlideLoad: function () {
              $(".slide.active [data-aos]").addClass("aos-animate");
            },

            beforeLeave: function (origin, destination) {
              const video = $("#video_hero")[0];
              const moveTo = $("#moveTo")[0];
              const toggleSideMenu = $(".side-menu-toggle")[0];
              const productSectionNav = $(".product-section-nav")[0];

              if (destination.index === 0 && video) {
                video.play();
              }

              if (destination.index === 0 && toggleSideMenu) {
                toggleSideMenu.classList.remove("show");
              }

              if (destination.index === 0 && productSectionNav) {
                productSectionNav.classList.remove("show");
              }

              if (!menu_name) {
                if (destination.index === 0 && moveTo) {
                  moveTo.classList.remove("show");
                }
              }
            },

            afterLoad: function (origin, destination) {
              $(".section.active [data-aos]").addClass("aos-animate");
              const moveTo = $("#moveTo")[0];
              const toggleSideMenu = $(".side-menu-toggle")[0];
              const productSectionNav = $(".product-section-nav")[0];

              if (destination.index !== 0 && toggleSideMenu) {
                toggleSideMenu.classList.add("show");
              }

              if (destination.index !== 0 && productSectionNav) {
                productSectionNav.classList.add("show");
              }

              if (!menu_name) {
                if (destination.index !== 0 && moveTo) {
                  moveTo.classList.add("show");
                }
              }

              if ($(".text-image").hasClass("active")) {
                const counters = document.querySelectorAll(
                  ".active .number-counter",
                );
                const speed = 200;

                counters.forEach((counter) => {
                  const animate = () => {
                    const value = +counter.getAttribute("data-target");
                    const data = +counter.innerText;

                    const time = value / speed;
                    if (data < value) {
                      counter.innerText = Math.ceil(data + time);
                      setTimeout(animate, 1);
                    } else {
                      counter.innerText = value;
                    }
                  };

                  animate();
                });
              }

              if ($(".stats-panel").hasClass("active")) {
                const counters = document.querySelectorAll(
                  ".active .number-counter",
                );
                const speed = 200;

                counters.forEach((counter) => {
                  const animate = () => {
                    const value = +counter.getAttribute("data-target");
                    const data = +counter.innerText;

                    const time = value / speed;
                    if (data < value) {
                      counter.innerText = Math.ceil(data + time);
                      setTimeout(animate, 1);
                    } else {
                      counter.innerText = value;
                    }
                  };

                  animate();
                });
              }

              if ($(".testimonials").hasClass("active")) {
                const counters = document.querySelectorAll(
                  ".active .number-counter",
                );
                const speed = 200;

                counters.forEach((counter) => {
                  const animate = () => {
                    const value = +counter.getAttribute("data-target");
                    const data = +counter.innerText;

                    const time = value / speed;
                    if (data < value) {
                      counter.innerText = Math.ceil(data + time);
                      setTimeout(animate, 1);
                    } else {
                      counter.innerText = value;
                    }
                  };

                  animate();
                });
              }
            },
          });
        }

        if (!menu_name) {
          $(document).on("click", "#moveTo", function () {
            fullpage_api.moveTo(1);
          });
        }
      }
    } else {
      if (document.querySelector("#fullpage")) {
        new fullpage("#fullpage", {
          scrollOverflow: true,
          lockAnchors: false,
          normalScrollElements: "#heroModal",
          css3: false,

          afterSlideLoad: function () {
            $(".slide.active [data-aos]").addClass("aos-animate");
          },

          beforeLeave: function (origin, destination) {
            const video = $("#video_hero")[0];
            const moveTo = $("#moveTo")[0];
            const toggleSideMenu = $(".side-menu-toggle")[0];

            if (destination.index === 0 && video) {
              video.play();
            }

            if (destination.index === 0 && toggleSideMenu) {
              toggleSideMenu.classList.remove("show");
            }

            if (destination.index === 0 && moveTo) {
              moveTo.classList.remove("show");
            }
          },

          afterLoad: function (origin, destination) {
            $(".section.active [data-aos]").addClass("aos-animate");
            const moveTo = $("#moveTo")[0];
            const toggleSideMenu = $(".side-menu-toggle")[0];

            if (destination.index !== 0 && toggleSideMenu) {
              toggleSideMenu.classList.add("show");
            }

            if (destination.index !== 0 && moveTo) {
              moveTo.classList.add("show");
            }

            if ($(".text-image").hasClass("active")) {
              const counters = document.querySelectorAll(
                ".active .number-counter",
              );
              const speed = 200;

              counters.forEach((counter) => {
                const animate = () => {
                  const value = +counter.getAttribute("data-target");
                  const data = +counter.innerText;

                  const time = value / speed;
                  if (data < value) {
                    counter.innerText = Math.ceil(data + time);
                    setTimeout(animate, 1);
                  } else {
                    counter.innerText = value;
                  }
                };

                animate();
              });
            }

            if ($(".stats-panel").hasClass("active")) {
              const counters = document.querySelectorAll(
                ".active .number-counter",
              );
              const speed = 200;

              counters.forEach((counter) => {
                const animate = () => {
                  const value = +counter.getAttribute("data-target");
                  const data = +counter.innerText;

                  const time = value / speed;
                  if (data < value) {
                    counter.innerText = Math.ceil(data + time);
                    setTimeout(animate, 1);
                  } else {
                    counter.innerText = value;
                  }
                };

                animate();
              });
            }

            if ($(".testimonials").hasClass("active")) {
              const counters = document.querySelectorAll(
                ".active .number-counter",
              );
              const speed = 200;

              counters.forEach((counter) => {
                const animate = () => {
                  const value = +counter.getAttribute("data-target");
                  const data = +counter.innerText;

                  const time = value / speed;
                  if (data < value) {
                    counter.innerText = Math.ceil(data + time);
                    setTimeout(animate, 1);
                  } else {
                    counter.innerText = value;
                  }
                };

                animate();
              });
            }
          },
        });
      }

      $(document).on("click", "#moveTo", function () {
        fullpage_api.moveTo(1);
      });
    }

    $("[data-menu-underline-from-center] a").addClass("underline-from-center");
    
    if($('[data-fancybox="images"]').length) {
      $().fancybox({
        selector: '[data-fancybox="images"]',
        loop: true,
      });
    };
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $(".no-fullpage .move-to").addClass("show");
    } else {
      $(".no-fullpage .move-to").removeClass("show");
    }
  });


  //Ajax infinite scrolling for blog posts
  if ($("#ajax-content").length) {
    var ajaxLoading = false;
    $(window).scroll(function () {
      var page = $("#ajax-content").data("page");
      var newPage = page + 1;
      var ajaxurl = $("#ajax-content").data("url");
      //When bottom of blog post wrapper is in view, fetch some more posts to fill it with.
      if (
        $(window).scrollTop() >=
          $("#ajax-content").offset().top +
            $("#ajax-content").outerHeight() -
            window.innerHeight &&
        ajaxLoading == false
      ) {
        //ajax call
        ajaxLoading = true;
        $(".loading-more").removeClass("hidden");
        $.ajax({
          url: ajaxurl,
          type: "post",
          data: {
            page: page,
            action: "ajax_script_load_more",
          },
          error: function (response) {
            console.log(response);
          },
          success: function (response) {
            if (response == 0) {
              //Show a message if more posts not available
              if ($("#no-more").length == 0) {
                //$('#ajax-content').append('<div id="no-more" class="text-center"><h3>You reached the end of the line!</h3><p>No more posts to load.</p></div>');
              }
            } else {
              //Update the page counter and add in the HTML for the fetched posts.
              $("#ajax-content").data("page", newPage);
              $("#ajax-content").append(response);
              setTimeout(function () {
                $(".hidden-posts").removeClass("hidden-posts");
              }, 100);
              //
            }
            ajaxLoading = false;
            $(".loading-more").addClass("hidden");
          },
        });
      }
    });
  }

  $(".side-menu-fade").on("click", function (e) {
    $(".side-menu, .side-menu-fade").removeClass("active");
    setTimeout(function () {
      $(".side-menu-fade").addClass("disabled");
    }, 700);
  });

  $(".side-menu li img").on("click", function (e) {
    e.preventDefault();

    //Makes it so that you can collapse the current item
    if ($(this).parent().parent().hasClass("expanded")) {
      $(".side-menu .menu-item.expanded .sub-menu").slideUp(500);
      $(".side-menu .menu-item.expanded").removeClass("expanded");
      return;
    }

    //Should this icon expand into a list?
    if ($(this).parent().parent().hasClass("menu-item-has-children")) {
      $(".side-menu .menu-item.expanded .sub-menu").slideUp(500);
      $(".side-menu .menu-item.expanded").removeClass("expanded");

      $(this).parent().siblings(".sub-menu").toggleClass("active");
      $(this).parent().siblings(".sub-menu").slideToggle(500);

      //Show this item
      $(this).parent().parent().toggleClass("expanded");
    } else {
      window.location.href = $(this).parent().siblings("a").attr("href");
    }
  });

  $(".side-menu-toggle").on("click", function (e) {
    $(".side-menu, .side-menu-fade").addClass("active");
    $(".side-menu-fade").removeClass("disabled");
  });

  $(".side-menu-close").on("click", function (e) {
    $(".side-menu, .side-menu-fade").removeClass("active");
    setTimeout(function () {
      $(".side-menu-fade").addClass("disabled");
    }, 700);
  });
})(jQuery);
